module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "border-error-container",
    class: _vm.hasError
  }, [_c('survey-caption', {
    attrs: {
      "ind": _vm.ind
    }
  }, [_vm._v(_vm._s(_vm.caption))]), _vm._v(" "), _c('div', {
    staticClass: "row survey-options-container center-flex-mobile"
  }, _vm._l((_vm.options), function(option, index) {
    return _c('div', {
      key: index,
      staticClass: "span-2-lg span-3-md span-3-sm span-3-xs relative survey-option-outer ratio-survey-card",
      class: _vm.getFirstOption(index)
    }, [_c('div', {
      ref: index,
      refInFor: true,
      staticClass: "survey-option-inner text-center",
      class: _vm.isCurrent(index),
      on: {
        "click": function($event) {
          _vm.setOption(index)
        }
      }
    }, [_c('h1', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('p', {
      staticClass: "hide-sm"
    }, [_vm._v(_vm._s(option))])])])
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ed66321"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/organisms/surveyResponse.vue
// module id = 599
// module chunks = 1